export const inputDescriptions = {
  generalInfo: {
    name: 'Name of Your venue.',
    description:
      'Describe your property in detail. Be creative in order to capture attention. Some ideas: What makes it interesting, describe indoor / outdoor spaces, rooms, its location.',
    checkIns:
      'Provide check-in and check-out info. The standard check-in is at 14:00 and check-out at 10:00.',
    address:
      'The address of your property. The address will be parsed to the coordinates, city, country and destination. Example: Carrer de la Marina, 19, 08005, Barcelona, Spain.',
    coordinates: 'Coordinates of your property Example: 41,3861745, 2,197559.',
    city: 'Generated city value from address, if not correct, please change it.',
    country:
      'Generated country value from address, if not correct, please change it.',
    countryCode:
      'Generated country code from address, if not correct, please change it.',
    destination:
      'Destination of your property. If you do not find a destination for your Venue, please create a new one.',
    venueType: 'Select the type of your property.',
    isEntireHouse:
      'Select this option, if you are providing your venue as a single bookable unit. You will not be asked to provide room details at the step 4.',
    price:
      'What’s the price per night? (For an entire property. If your prices vary based on the season and availability, include ‘Starting at’ price. This price is non-binding.).',
    ical: 'If you have an iCal link for your calendar, please include it. This is a way to allow potential guests to see the live availability of your property on NextRetreat. (optional)',
  },
  images: {
    thumbnail:
      'Upload an image that will be used as a cover photo / thumbnail of your property. Ideally an image of the venue exterior.',
    photos:
      'Upload all other photos of your property. Pick the best ones. We recommend having in total between 20 - 40 photos. If you are providing separate rooms to book, you will be asked to upload photos for each of the room. Duplicate images will be removed from the venue and the images will be ordered automatically to provide the best user experience for the customers. (max. image size 2MB)',
  },
  additionalInfo: {
    amenities:
      'Select the amenities for your venue. You have to select at least 12 amenities to help the user make better decisions when comparing venues. There are 11 groups of amenities. We recommend you to select at least 4 - 5 from each group to provide the best experience for the customer. The amenities are ordered by their frequency. There may be duplicates, please select only one. To load more amenities from a group, press "Show more...".',
    customAmenities:
      'Anything else you would like to add? Please separate the amenities with a coma (eg. washing machine, communal areas etc.) (optional)',
    internetSpeed: 'What’s the internet speed at your property? (optional)',
    carbonEmissionRoom:
      'Provide the average emission of CO2 for a room / night. If you do not know this value, we will automatically fill it from https://www.hotelfootprints.org/ website.',
    carbonEmissionMeeting:
      'Provide the average emission of CO2 for a meeting room. If you do not know this value, we will automatically fill it from https://www.hotelfootprints.org/ website.',
    hasMeetingRooms:
      'Please check this field if you have a dedicate space suitable for meetings, workshops, presentations etc. If you have a meeting or communal space, you will be asked to fill out the details in the step 5.',
  },

  rooms: {
    name: "Name of the room. If the room do not have a sspecial name, include if it's a single, double, twin, triple room...",
    description:
      'A short description to help customers decide between the rooms. Include additional amenities in the description, if there are additional to the ones selected in the step 3.',
    size: 'How big is the room in square meters? (1 square foot is 0.93 square meters)',
    quantity: 'How many rooms of this type do you have?',
    capacity: 'How many people could sleep here?',
    thumbnail:
      'Upload the first image, which will be used as a room’s main photo / thumbnail. Ideally a photo wich captures the most of the room. (Not a bathroom photo)',
    photos:
      'Upload all other images specific to this type of room. Please provide images with similar orientation. For example only landscape photos. This will increase the user experience. (max. image size 2MB)',
    variations: {
      add: 'Variations are required to continue. Add price, capacity and mealing option here. If your Room has a different pricing for different amount of people or mealing options, please add more variations. (For example the price can differ if there is only breakfast included or all-inclusive mealing)',
      capacity:
        'The actual capacity for this specific variation. Can not be higher than the maximum capacity of the room provided above.',
      meal: 'The actual mealing option for this specific variation.',
      description:
        'How would you like to call this variation, eg. Twin room - option 1 (optional)',
      lowRate:
        'Enter the lowest / starting at price for this variation (capacity - mealing combination). Always include prices in EUR. Low rate for the whole room will be the minimum value from the variations for that room. (This price is non-binding.)',
    },
  },

  meetingRooms: {
    name: 'Name of the meeting room',
    description:
      'Description of the meeting room with all the amnities included in the room. For example: flipchart, projector and daylight.',
    size: 'Size of the meeting room in square meters? (1 square foot is 0.93 square meters)',
    quantity: 'Do you have more meeting rooms like this one? Include how many.',
    capacity: 'How many people could it host?',
    thumbnail:
      'Upload the first image which will be used as the meeting room’s cover photo / thumbnail.',
    photos:
      'Upload other images of your meeting room. Please provide images with similar orientation. For example only landscape photos. This will increase the user experience. (max. image size 2MB)',
    variations: {
      add: 'Add price and other details here. If your Meeting Room can host different number of people with different prices, or seating layout please add more variations.',
      capacity:
        'Number of people the meeting room can fit with the specified seating layout.',
      tableOrganisation:
        'Select a seating layout. Check out the layouts here: https://www.socialtables.com/blog/meeting-event-design/room-layouts/',
      description: 'How would you like to call this variation (optional)',
      lowRate:
        'What is the cost of renting this space per day? If the space is free (eg. already included in the price of property), add 0. Always include prices in EUR. (This price is non-binding.)',
    },
  },

  ownerInfo: {
    name: 'Provide your full name. (First and Last name)',
    email: 'Provide an official email address',
    phone: 'Please include country prefix, eg +44',
  },
}
